export default "__VITE_ASSET__Cnb1jo1s__"